import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseURL, VERSION } from '../constant/constant';
import { getTimeZoneHeader } from '../constant/globalFunction';

@Injectable({
  providedIn: 'root'
})
export class AuditlogService {

  constructor(private http:HttpClient) { }

  postLoggedInLog(payload: any):Observable<any>{
    return this.http.post(`${baseURL}auditlog/${VERSION}/login`, payload, {headers:getTimeZoneHeader()});
  }

}
